// NATIVE 
import { useCallback, useEffect, useRef, useState } from 'react';

// INSTALLED 
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, Divider, Grid, IconButton, Snackbar, Tooltip, Typography } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { SnackbarProvider, VariantType, useSnackbar } from 'notistack';


// CUSTOM 
import InputField from '../../formFields/InputField';
import InputNumeric from '../../formFields/InputNumeric';
import CheckboxField from '../../formFields/checkBoxField';
import AutocompleteField from '../../formFields/autocompleteField';
import { IDatosBasicos } from '../../../commons/interfaces';
import DatePickerField from '../../formFields/datePickerField';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { uploadPdfStore } from '../../../store/uploaders';
import { SnackAlert } from '../../SnackAlert';
import { SnackGroupAlerts } from '../../SnackGroupAlerts';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';
import TextAreaField from '../../formFields/TextAreaField';
import { Padding } from '@mui/icons-material';





export const Dotacion = (props:any) => {



    


  const dotacionList =  [
    {
      label:  "bata mantenimiento",
      value:  "bata_mantenimiento"
    },
    {
      label:  "blazer",
      value:  "blazer"
    },
    {
      label:  "blusa",
      value:  "blusa"
    },
    {
      label:  "botas",
      value:  "botas"
    },
    {
      label:  "bufanda",
      value:  "bufanda"
    },
    {
      label:  "camisa",
      value:  "camisa"
    },
    {
      label:  "chaqueta impermeable",
      value:  "chaqueta_impermeable"
    },
    {
      label:  "corbata",
      value:  "corbata"
    },
    {
      label:  "delantal",
      value:  "delantal"
    },
    {
      label:  "falda short",
      value:  "falda_short"
    },
    {
      label:  "grillo",
      value:  "grillo"
    },
    {
      label:  "jean",
      value:  "jean"
    },
    {
      label:  "pantalon",
      value:  "pantalon"
    },
    {
      label:  "zapatos",
      value:  "zapatos"
    }
  ];



  const dotacionListDos =  [
    {
      label:  "bata mantenimiento",
      value:  "bata_mantenimiento"
    },
    {
      label:  "blazer",
      value:  "blazer"
    },
    {
      label:  "blusa",
      value:  "blusa"
    },
    {
      label:  "botas",
      value:  "botas"
    },
    {
      label:  "bufanda",
      value:  "bufanda"
    },
    {
      label:  "camisa",
      value:  "camisa"
    },
    {
      label:  "chaqueta impermeable",
      value:  "chaqueta_impermeable"
    },
    {
      label:  "corbata",
      value:  "corbata"
    },
    {
      label:  "delantal",
      value:  "delantal"
    },
    {
      label:  "falda short",
      value:  "falda_short"
    },
    {
      label:  "grillo",
      value:  "grillo"
    },
    {
      label:  "jean",
      value:  "jean"
    },
    {
      label:  "pantalon",
      value:  "pantalon"
    },
    {
      label:  "zapatos",
      value:  "zapatos"
    }
  ];



  return (
    <div>

    <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 4, marginBottom: 2, paddingLeft: 2, background: '#eceaea', padding: 1 }}>Item 1</Typography>
    <Grid container spacing={2} style={{ marginTop: 10 }}>

      <Grid item xs={2}>
            <AutocompleteField 
                options={dotacionList}
                name={'items_item1'}
                label={'item item 1'}
                element={'items_item1'}
            />
      </Grid>
      <Grid item xs={2}>
          <InputField
              name={'items_talla1'}
              label={'talla item 1'}
              variant="outlined" 
              fullWidth
            />
      </Grid>
      <Grid item xs={2}>
         <InputNumeric 
            name={'items_cantidad1'}
            label={'cantidad item 1'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={2}>
          <InputField 
            name={'items_color1'}
            label={'color item 1'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={4}>
          <TextAreaField 
            name={'items_descripcion1'}
            label={'descripcion 1'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
          

    </Grid>
    {/* END GRID  */}
    <Divider sx={{ marginTop: 3 }}/>
    <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 4, marginBottom: 2, paddingLeft: 2, background: '#eceaea', padding: 1 }}>Item 2</Typography>
    <Grid container spacing={2} style={{ marginTop: 10 }}>

      <Grid item xs={2}>
            <AutocompleteField 
                options={dotacionListDos}
                name={'items_item2'}
                label={'item item 2'}
                element={'items_item2'}
            />
      </Grid>
      <Grid item xs={2}>
          <InputField
              name={'items_talla2'}
              label={'talla item 2'}
              variant="outlined" 
              fullWidth
            />
      </Grid>
      <Grid item xs={2}>
         <InputNumeric 
            name={'items_cantidad2'}
            label={'cantidad item 2'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={2}>
          <InputField 
            name={'items_color2'}
            label={'color item 2'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={4}>
          <TextAreaField 
            name={'items_descripcion2'}
            label={'descripcion item 2'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
          

    </Grid>
    {/* END GRID  */}
    <Divider sx={{ marginTop: 3 }}/>
    <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 4, marginBottom: 2, paddingLeft: 2, background: '#eceaea', padding: 1 }}>Item 3</Typography>
    <Grid container spacing={2} style={{ marginTop: 10 }}>

      <Grid item xs={2}>
            <AutocompleteField 
                options={dotacionList}
                name={'items_item3'}
                label={'item 3'}
                element={'items_item3'}
            />
      </Grid>
      <Grid item xs={2}>
          <InputField
              name={'items_talla3'}
              label={'talla item 3'}
              variant="outlined" 
              fullWidth
            />
      </Grid>
      <Grid item xs={2}>
         <InputNumeric 
            name={'items_cantidad3'}
            label={'cantidad item 3'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={2}>
          <InputField 
            name={'items_color3'}
            label={'color item 3'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={4}>
          <TextAreaField 
            name={'items_descripcion3'}
            label={'descripcion item 3'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
          

    </Grid>
    {/* END GRID  */}
    <Divider sx={{ marginTop: 3 }}/>

    <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 4, marginBottom: 2, paddingLeft: 2, background: '#eceaea', padding: 1 }}>Item 4</Typography>
    <Grid container spacing={2} style={{ marginTop: 10 }}>

      <Grid item xs={2}>
            <AutocompleteField 
                options={dotacionList}
                name={'items4'}
                label={'item 4'}
                element={'items4'}
            />
      </Grid>
      <Grid item xs={2}>
          <InputField
              name={'items_talla4'}
              label={'talla item 4'}
              variant="outlined" 
              fullWidth
            />
      </Grid>
      <Grid item xs={2}>
         <InputNumeric 
            name={'items_cantidad4'}
            label={'cantidad item 4'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={2}>
          <InputField 
            name={'items_color4'}
            label={'color item 4'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={4}>
          <TextAreaField 
            name={'items_descripcion4'}
            label={'descripcion item 4'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
          

    </Grid>
    {/* END GRID  */}
    <Divider sx={{ marginTop: 3 }}/>
    <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 4, marginBottom: 2, paddingLeft: 2, background: '#eceaea', padding: 1 }}>Item 5</Typography>
    <Grid container spacing={2} style={{ marginTop: 10 }}>

      <Grid item xs={2}>
            <AutocompleteField 
                options={dotacionList}
                name={'items5'}
                label={'item 5'}
                element={'items5'}
            />
      </Grid>
      <Grid item xs={2}>
          <InputField
              name={'items_talla5'}
              label={'talla item 5'}
              variant="outlined" 
              fullWidth
            />
      </Grid>
      <Grid item xs={2}>
         <InputNumeric 
            name={'items_cantidad5'}
            label={'cantidad item 5'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={2}>
          <InputField 
            name={'items_color5'}
            label={'color item 5'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
      <Grid item xs={4}>
          <TextAreaField 
            name={'items_descripcion5'}
            label={'descripcion item 5'}
            variant="outlined" 
            fullWidth
          />
      </Grid>
          

    </Grid>
    {/* END GRID  */}


    </div>
  )
}
